<div class="pb-3 pb-lg-4 mb-0  pt-md-3 container">
    <p class="check-fit-title">Check Fitment</p>
    <div class="table-wrapper my-md-4" *ngIf="tableData?.length">
        <table class="table table-bordered table-striped responsive-table">
            <thead>
                <tr>
                    <th *ngFor="let header of headerLabels">
                        {{ header }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of tableData">
                    <td *ngFor="let key of tableKeys; let i = index" [attr.data-label]="headerLabels[i]">
                        {{ row[key] }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <p *ngIf="!tableData?.length" class="text-center">
        No fitment data available
    </p>
</div>